import React, { Component } from "react";
import { connect } from "react-redux";
import classes from "./MobileHome.css";
import Box from "../../../hoc/Box/Box";
import * as actions from "../../../store/actions/index";
import withErrorHandler from "../../../hoc/withErrorHandler/withErrorHandler";
import api from "../../../axios-local-api";
import { FaExclamationTriangle } from "react-icons/fa";
import MobileHomeSwitch from "../MobileHomeSwitch/MobileHomeSwitch";
import { FaSync, FaSpinner, FaSatelliteDish, FaSortDown } from "react-icons/fa";
import Spinner from "../../../components/UI/Spinner/Spinner";

export class MobileHomeStatus extends Component {
    constructor(props) {
        super(props);
        this.state = {
            error: false,
            success: true,
            loading: false,
            loaded: false,
            data: null,
            mode: props.mobileHomeMode ? props.mobileHomeMode : "N/A",
            active: props.mobileHomeActive ? props.mobileHomeActive : "Not supported",
            bandCounts: {},
            devices: [],
            pods: [],
            connectedDeviceCount: 0,
            connectedPodsCount: 0,
        };
    }

    normalizeBand(freqBand) {
        const b = freqBand.trim().toUpperCase();
        if (b.includes("2.4")) return "2.4 GHz";
        const match = b.match(/(\d+(?:\.\d+)?)G/);
        return match ? `${match[1]} GHz` : freqBand.trim();
    }

    addDevicesToStatusbar() {
        if (this.props.devices && this.props.devices.length) {
            const bandCounts = {};
            this.props.devices.forEach((device) => {
                if (device.freqBand) {
                    const band = this.normalizeBand(device.freqBand);
                    bandCounts[band] = (bandCounts[band] || 0) + 1;
                }
            });
            this.setState({
                bandCounts,
                devices: this.props.devices,
                connectedDeviceCount: this.props.realWan.connectedDeviceCount,
            });
        }
    }

    addPodsToStatusBar() {
        if (this.props.connectedPodsCount && this.props.connectedPodsCount > 0) {
            const routerMac = this.props.realWan?.id;
            const podBandCounts = {};
            const inc = (freqBand) => {
                const band = this.normalizeBand(freqBand);
                podBandCounts[band] = (podBandCounts[band] || 0) + 1;
            };

            this.props.connectedPods.forEach((pod) => {
                if (
                    pod.leafToRoot &&
                    pod.leafToRoot.length &&
                    this.props.realWan &&
                    pod.leafToRoot[0].id === this.props.realWan.id
                ) {
                    if (pod.backhaulType === "wifi" && pod.backHaul?.metadata?.freqBand)
                        inc(pod.backHaul.metadata.freqBand);

                    const parentId = pod.leafToRoot && pod.leafToRoot.length ? pod.leafToRoot[0].id : undefined;
                    const wifiParentId = parentId === undefined ? "ETHERNET" : parentId;
                    const connectedToRouter = wifiParentId === "ETHERNET" ? undefined : wifiParentId === routerMac;

                    if (connectedToRouter === true && pod.backHaul?.metadata?.freqBand)
                        inc(pod.backHaul.metadata.freqBand);
                }
            });

            this.setState((s) => {
                const merged = { ...s.bandCounts };
                Object.entries(podBandCounts).forEach(([band, count]) => {
                    merged[band] = (merged[band] || 0) + count + 1;
                });
                return { bandCounts: merged, connectedPodsCount: this.props.connectedPodsCount };
            });
        }
    }

    componentDidMount() {
        if (this.props.devices && this.props.realWan.connectedDeviceCount !== this.state.connectedDeviceCount)
            this.addDevicesToStatusbar();
        if (this.props.connectedPods && this.props.connectedPodsCount !== this.state.connectedPodsCount)
            this.addPodsToStatusBar();
    }

    componentDidUpdate() {
        if (this.props.devices && this.props.realWan.connectedDeviceCount !== this.state.connectedDeviceCount)
            this.addDevicesToStatusbar();
        if (this.props.connectedPods && this.props.connectedPodsCount !== this.state.connectedPodsCount)
            this.addPodsToStatusBar();
    }

    render() {
        let routerTitle;
        let rModel = this.props.realWan ? this.props.realWan.model : "Router";
        const isMobileSwitchEnabled = this.props.mobileHome.mode && this.props.mobileHome.mode !== "disable" ? true : false;
        let inLimit;
        let outLimit;
        switch (rModel) {
            case "SAC2V2S":
                routerTitle = "Sagemcom Wave 2";
                inLimit = 45;
                outLimit = 50;
                break;
            case "SAC2V1K":
                routerTitle = "Askey Wave 2";
                inLimit = 122;
                outLimit = 127;
                break;
            case "SAC2V1A":
                routerTitle = "Commscope Wave 2";
                inLimit = 122;
                outLimit = 127;
                break;
            case "SAX1V1S":
                routerTitle = "Sagemcom WiFi 6";
                inLimit = 80;
                outLimit = 85;
                break;
            case "SAX1V1K":
                routerTitle = "Askey WiFi 6";
                inLimit = 122;
                outLimit = 127;
                break;
            case "SAX1V1R":
                routerTitle = "Sercomm WiFi 6";
                inLimit = 122;
                outLimit = 127;
                break;
            default:
                routerTitle = rModel;
                inLimit = 45;
                outLimit = 50;
        }

        const currentLimit = this.state.mode === "disable" ? outLimit : inLimit;
        // console.log('DEBUG', currentLimit);

        const renderBandBar = (band, count) => (
            <div key={band} className={classes.mobFive}>
                <div style={{ display: "flex", flexDirection: "row", justifyContent: "space-between" }}>
                    <div style={{ color: "#555" }}>{band}</div>
                   {/* { count > 0 ? <div style={{ color: "#555", fontSize: "12px" }}>{count} devices</div> : '' } */}
                </div>
                <div
                    style={{
                        boxSizing: "content-box",
                        height: 20,
                        position: "relative",
                        margin: "4px 0 0 0",
                        background: "#ddd",
                        borderRadius: 25,
                        width: 200,
                    }}
                >
                    <span
                        style={{
                            paddingLeft: (count * 100) / currentLimit > 0 ? "4px" : "0px",
                            display: "block",
                            height: "100%",
                            borderRadius: (count * 100) / currentLimit <= 5 ? "25px 0px 0px 25px" : 20,
                            backgroundColor: this.props.checkingWan
                                ? ""
                                : 100 - (count * 100) / currentLimit <= 5
                                ? "red"
                                : "#0073d1",
                            position: "relative",
                            overflow: "hidden",
                            width:
                                (count * 100) / currentLimit > 106
                                    ? "100%"
                                    : ((count * 100) / currentLimit).toString() + "%",
                        }}
                    />
                </div>
            </div>
        );

        const defaultBands = { "2.4 GHz": 0, "5 GHz": 0 , "6 GHz": 0};
        const mergedBands = { ...defaultBands, ...this.state.bandCounts };
        const bandBars = Object.entries(mergedBands).map(([band, count]) => renderBandBar(band, count));
        let routerInfo = (
            <div style={{ display: "flex", flexDirection: "row" }}>
                <div
                    className={classes.ComponentTitle}
                    style={{ display: "flex", flexDirection: "column", justifyContent: "flex-start" }}
                >
                    <h3>Spectrum Mobile Access Point</h3>
                </div>
            </div>
        );
        let mobileHomeMsg;
        let mobileHomeIcon = (
            <div className={classes.isMobileSwitchEnabled}>
                <FaExclamationTriangle color={"#dcc000"} fontSize={"30px"} style={{ marginRight: "5px", marginTop: "10px" }} />
            </div>
        );

        let mobileHomeSwitch;
        if (this.props.mobileHomeActive === "Active") {
            mobileHomeSwitch = <MobileHomeSwitch />;
        }

        const nearLimitEntry = Object.entries(this.state.bandCounts).find(
            ([, count]) => 100 - (count * 100) / currentLimit <= 5
        );
        if (nearLimitEntry) {
            const [band] = nearLimitEntry;
            mobileHomeMsg = (
                <span id="MobileHomeText" className={classes.MobileHomeNoInfo}>
                    {" "}
                    {band === "5G"
                        ? isMobileSwitchEnabled
                            ? "5 GHz band is approaching maximum limit of connected devices. Public SSID is enabled, please consider disabling the feature"
                            : "5 GHz band is approaching maximum limit of connected devices. Public SSID is currently disabled. Please consider network impact before enabling the feature"
                        : `${band} band is approaching max limit of connected devices. Please review connected devices.`}
                </span>
                
            );
        }

        let messageArea;
        const anyBandNearLimit = Object.values(this.state.bandCounts).some(
            (count) => 100 - (count * 100) / currentLimit <= 5
        );
        if (this.state.active !== "Active" || anyBandNearLimit) {
            messageArea = (
                <div className={classes.mobileHomeMessage}>
                    <div className={classes.TitleArea}>
                        <div
                            className={[classes.TitleLeft, classes.showDesktop].join(" , ")}
                            style={{ justifyContent: "flex-start" }}
                        >
                            <div style={{ display: "flex", flexDirection: "row", alignItems: "center" }}>
                                {mobileHomeIcon}
                                {mobileHomeMsg}
                            </div>
                        </div>

                        <div className={classes.showMobile}>
                            <div style={{ display: "flex", flexDirection: "column" }}>
                                <div style={{ display: "flex", alignItems: "center" }}>
                                    {mobileHomeIcon}
                                    {mobileHomeMsg}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            );
        } else {
            messageArea = <div />;
        }
        // console.log("this props", this.props);
        return (
            <Box>
                <div className={classes.MobileHome}>
                    <div className={classes.TitleArea}>
                        <div className={classes.TitleLeft}>
                            {routerInfo}
                            <div className={classes.showMobile}>{mobileHomeSwitch}</div>
                        </div>
                        <div className={classes.showDesktop}>
                            <div className={classes.TitleRight}>
                                {bandBars.map((bar, i) => (
                                    <React.Fragment key={i}>
                                        {bar}
                                        {i < bandBars.length - 1 && <div style={{ width: 15, height: 10 }} />}
                                    </React.Fragment>
                                ))}
                                {mobileHomeSwitch}
                            </div>
                        </div>
                        <div className={classes.showMobile}>
                            <div className={classes.TitleRight}>
                                {bandBars.map((bar, i) => (
                                    <React.Fragment key={i}>
                                        {bar}
                                        {i < bandBars.length - 1 && <div style={{ width: 15, height: 10 }} />}
                                    </React.Fragment>
                                ))}
                            </div>
                        </div>
                    </div>
                    {(this.props.mobileLoading || !this.props.mobileLoaded) && (
                        <div
                            style={{
                                maxWidth: 200,
                                padding: 2,
                                marginTop: 0,
                                marginBottom: 20,
                                marginLeft: 20,
                                backgroundColor: "#ddd",
                                borderRadius: 5,
                            }}
                        >
                            <div
                                style={{
                                    display: "flex",
                                    flexDirection: "row",
                                    justifyContent: "flex-start",
                                    paddingLeft: 10,
                                    alignItems: "center",
                                }}
                            >
                                <Spinner fontSize={2} margin={1} gray={true}>
                                    {" "}
                                </Spinner>
                                <span style={{ padding: 2, margin: 3, color: "#555" }}>Working</span>
                            </div>
                        </div>
                    )}
                    {!this.props.mobileLoading &&
                        this.props.mobileLoaded &&
                        this.props.mobileHome &&
                        this.props.mobileHomeMode === "enable" &&
                        !this.props.mobileHome.vapEnabled && (
                            <div
                                style={{
                                    maxWidth: 200,
                                    padding: 2,
                                    marginTop: 0,
                                    marginBottom: 20,
                                    marginLeft: 20,
                                    backgroundColor: "#ffbfc2",
                                    borderRadius: 5,
                                }}
                            >
                                <div
                                    style={{
                                        flexDirection: "row",
                                        justifyContent: "flex-start",
                                        alignItems: "center",
                                        padding: 5,
                                        paddingLeft: 10,
                                    }}
                                >
                                    <svg width="20" height="20" viewBox="0 0 12 13" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path
                                            d="M4.65541 2.43741C4.39326 2.43741 4.17878 2.69052 4.17878 2.99988C4.17878 3.30925 4.39227 3.56236 4.65541 3.56236C6.23247 3.56236 7.5152 5.07613 7.5152 6.93723C7.5152 7.24894 7.72969 7.49971 7.99184 7.49971C8.25398 7.49971 8.46847 7.24777 8.46847 6.93723C8.46847 4.4553 6.75855 2.43741 4.65541 2.43741ZM4.81429 0C4.46277 0 4.17878 0.335378 4.17878 0.749971C4.17878 1.16456 4.46337 1.49994 4.81429 1.49994C7.26696 1.49994 9.26286 3.85532 9.26286 6.74974C9.26286 7.16433 9.54744 7.49971 9.89837 7.49971C10.2493 7.49971 10.5339 7.16433 10.5339 6.74974C10.5339 3.02801 7.968 0 4.81429 0ZM4.11721 8.10906L4.66077 7.4676C4.7129 7.48225 4.76124 7.5029 4.81586 7.5029C5.16837 7.5029 5.45117 7.16869 5.45117 6.75293C5.45117 6.33997 5.16837 6.00272 4.81586 6.00272C4.46593 6.00272 4.18055 6.33974 4.18055 6.75293C4.18055 6.82031 4.19663 6.87597 4.21153 6.93749L3.6664 7.5794L1.34619 4.83966C1.20221 4.66974 0.946617 4.69904 0.867575 4.90997C0.0384337 6.73521 0.274168 9.05121 1.57756 10.591C2.88075 12.1289 4.84646 12.4073 6.39154 11.4289C6.57276 11.3117 6.59769 11.0129 6.45112 10.8429L4.11721 8.10906Z"
                                            fill="#7a0006"
                                        />
                                        <line
                                            y1="-0.5"
                                            x2="15.7172"
                                            y2="-0.5"
                                            transform="matrix(-0.645812 0.763497 -0.645812 -0.763497 10.5337 0)"
                                            stroke="#7a0006"
                                        />
                                    </svg>
                                    <span id="NotBroadcasting" style={{ padding: 2, margin: 0, color: "#7a0006" }}>
                                        {" "}
                                        Not Broadcasting
                                    </span>
                                </div>
                            </div>
                        )}

                    {!this.props.mobileLoading &&
                        this.props.mobileLoaded &&
                        this.props.mobileHome &&
                        this.props.mobileHomeMode === "enable" &&
                        this.props.mobileHome.vapEnabled && (
                            <div
                                style={{
                                    maxWidth: 200,
                                    padding: 2,
                                    marginTop: 0,
                                    marginBottom: 20,
                                    marginLeft: 20,
                                    backgroundColor: "#c2ffbf",
                                    borderRadius: 5,
                                }}
                            >
                                <div
                                    style={{
                                        flexDirection: "row",
                                        justifyContent: "flex-start",
                                        alignItems: "center",
                                        padding: 5,
                                        paddingLeft: 10,
                                    }}
                                >
                                    <FaSatelliteDish fontSize={"18px"} color={"#09b300"} />
                                    <span id="Broadcasting" style={{ padding: 2, margin: 0, color: "#09b300" }}>
                                        {" "}
                                        Broadcasting
                                    </span>
                                </div>
                            </div>
                        )}
                    {!this.props.mobileLoading &&
                        this.props.mobileLoaded &&
                        (!this.props.mobileHome ||
                            (!this.props.mobileHome.vapEnabled && this.props.mobileHomeMode !== "enable")) && (
                            <div
                                style={{
                                    maxWidth: 200,
                                    padding: 2,
                                    marginTop: 0,
                                    marginBottom: 20,
                                    marginLeft: 20,
                                    backgroundColor: "#ddd",
                                    borderRadius: 5,
                                }}
                            >
                                <div
                                    style={{
                                        flexDirection: "row",
                                        justifyContent: "flex-start",
                                        alignItems: "center",
                                        padding: 5,
                                        paddingLeft: 10,
                                    }}
                                >
                                    <svg width="20" height="20" viewBox="0 0 12 13" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path
                                            d="M4.65541 2.43741C4.39326 2.43741 4.17878 2.69052 4.17878 2.99988C4.17878 3.30925 4.39227 3.56236 4.65541 3.56236C6.23247 3.56236 7.5152 5.07613 7.5152 6.93723C7.5152 7.24894 7.72969 7.49971 7.99184 7.49971C8.25398 7.49971 8.46847 7.24777 8.46847 6.93723C8.46847 4.4553 6.75855 2.43741 4.65541 2.43741ZM4.81429 0C4.46277 0 4.17878 0.335378 4.17878 0.749971C4.17878 1.16456 4.46337 1.49994 4.81429 1.49994C7.26696 1.49994 9.26286 3.85532 9.26286 6.74974C9.26286 7.16433 9.54744 7.49971 9.89837 7.49971C10.2493 7.49971 10.5339 7.16433 10.5339 6.74974C10.5339 3.02801 7.968 0 4.81429 0ZM4.11721 8.10906L4.66077 7.4676C4.7129 7.48225 4.76124 7.5029 4.81586 7.5029C5.16837 7.5029 5.45117 7.16869 5.45117 6.75293C5.45117 6.33997 5.16837 6.00272 4.81586 6.00272C4.46593 6.00272 4.18055 6.33974 4.18055 6.75293C4.18055 6.82031 4.19663 6.87597 4.21153 6.93749L3.6664 7.5794L1.34619 4.83966C1.20221 4.66974 0.946617 4.69904 0.867575 4.90997C0.0384337 6.73521 0.274168 9.05121 1.57756 10.591C2.88075 12.1289 4.84646 12.4073 6.39154 11.4289C6.57276 11.3117 6.59769 11.0129 6.45112 10.8429L4.11721 8.10906Z"
                                            fill="#555"
                                        />
                                        <line
                                            y1="-0.5"
                                            x2="15.7172"
                                            y2="-0.5"
                                            transform="matrix(-0.645812 0.763497 -0.645812 -0.763497 10.5337 0)"
                                            stroke="#D6312B"
                                        />
                                    </svg>
                                    <span id="NotBroadcasting" style={{ padding: 2, margin: 0, color: "#555" }}>
                                        {" "}
                                        Not Broadcasting
                                    </span>
                                </div>
                            </div>
                        )}
                    {!this.props.mobileLoading &&
                        this.props.mobileLoaded &&
                        this.props.mobileHome &&
                        this.props.mobileHomeMode === "auto" &&
                        this.props.mobileHome.vapEnabled && (
                            <div
                                style={{
                                    maxWidth: 200,
                                    padding: 2,
                                    marginTop: 0,
                                    marginBottom: 20,
                                    marginLeft: 20,
                                    backgroundColor: "#c2ffbf",
                                    borderRadius: 5,
                                }}
                            >
                                <div
                                    style={{
                                        flexDirection: "row",
                                        justifyContent: "flex-start",
                                        alignItems: "center",
                                        padding: 5,
                                        paddingLeft: 10,
                                    }}
                                >
                                    <FaSatelliteDish fontSize={"18px"} color={"#09b300"} />
                                    <span id="Broadcasting" style={{ padding: 2, margin: 0, color: "#09b300" }}>
                                        {" "}
                                        Broadcasting
                                    </span>
                                </div>
                            </div>
                        )}
                </div>
                {messageArea}
            </Box>
        );
    }
}
const mapStateToProps = (state) => ({
    loading: state.devices.loading,
    loaded: state.devices.loaded,
    realWan: state.wan.realWan,
    connectedPods: state.equipment.realEquipment.claimedPods.filter((pod) => pod.connectionState === "connected"),
    connectedPodsCount: state.equipment.realEquipment.claimedPods.filter((pod) => pod.connectionState === "connected")
        .length,
    mobileHomeActive:
        state.mobileHome.realMobileHome &&
        state.mobileHome.realMobileHome.subscription &&
        state.mobileHome.realMobileHome.subscription.status
            ? state.mobileHome.realMobileHome.subscription.status
            : null,
    mobileHome: state.mobileHome.realMobileHome,
    checkingWan: state.wan.checkingWan,
    mobileLoading: state.mobileHome.loading,
    mobileLoaded: state.mobileHome.loaded,
});

const mapDispatchToProps = (dispatch) => ({
    onMobileHomeHandler: (payload) => dispatch(actions.advancedSecurityHandler(payload)),
});

export default connect(mapStateToProps, mapDispatchToProps)(withErrorHandler(MobileHomeStatus, api));

